export default __webpack_public_path__ + "5f55185721e8f0f0529aeeab5b4a14f7.png";